import { React } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { strings } from '../localization/strings';

function Header({ currentStep, tourName, language, tourUrl }) {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state || {};
    const translation = strings[language] ?? strings.it;
    
  return (
    <div className="tourmaster-payment-head tourmaster-wihtout-background">
      <div className="traveltour-header-transparent-substitute"></div>
      <div className="tourmaster-payment-head-overlay-opacity"></div>
      <div className="tourmaster-payment-head-overlay"></div>
      <div className="tourmaster-payment-head-top-overlay"></div>
      <div className="tourmaster-payment-title-container tourmaster-container">
        <h1 className="tourmaster-payment-title tourmaster-item-pdlr">
          <a href={tourUrl}>{tourName}</a>
        </h1>
      </div>
      { currentStep !== "none" &&
      <div
        className="tourmaster-payment-step-wrap"
        id="tourmaster-payment-step-wrap"
        style={{background: (currentStep === "3" ? '#f5f5f5' : '#e0e0e0')}}
      >
        <div className="tourmaster-payment-step-container tourmaster-container" style={{display: 'flex', padding: '0'}}>
          <div className="tourmaster-payment-step-item tourmaster-left" />
          <div className="tourmaster-payment-step-inner clearfix">
            <div
              className={`tourmaster-payment-step-item ${currentStep === "1" ? "tourmaster-current" : "tourmaster-enable"}`}
              data-step="1"
              onClick={() => { if (parseInt(currentStep) > 1) navigate('/recap' + location.search, { state: state })}}
            >
              <span className="tourmaster-payment-step-item-icon">
                <i className="fa fa-check fa-xl"></i>
                <span className="tourmaster-text">1</span>
              </span>
              <span className="tourmaster-payment-step-item-title">
                {translation.headerCheckYourOrder}
              </span>
            </div>
            <div data-step="2"
            className={`tourmaster-payment-step-item ${currentStep === "2" ? "tourmaster-current" : (currentStep === "3" ? "tourmaster-enable" : "")}`}
            onClick={() => { if (parseInt(currentStep) > 2) navigate('/personal-data' + location.search, { state: state })}}>
              <span className="tourmaster-payment-step-item-icon">
                <i className="fa fa-check fa-xl"></i>
                <span className="tourmaster-text">2</span>
              </span>
              <span className="tourmaster-payment-step-item-title">{translation.headerYourData}</span>
            </div>
            <div data-step="3"
            className={`tourmaster-payment-step-item ${currentStep === "3" ? "tourmaster-current" : ""}`}>
              <span className="tourmaster-payment-step-item-icon">
                <i className="fa fa-check fa-xl"></i>
                <span className="tourmaster-text">3</span>
              </span>
              <span className="tourmaster-payment-step-item-title">{translation.headerPayment}</span>
            </div>
          </div>
        </div>
      </div> }
    </div>
  );
}

export default Header;
